module["exports"] = [
  "0.#.#",
  "0.##",
  "#.##",
  "#.#",
  "#.#.#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/app/version.js
 ** module id = 356
 ** module chunks = 0
 **/